import React from "react";
import { skills } from "../data/skills";

const Skills = () => {
  return (
    <section
      name="skills"
      id="skills"
      className="w-full md:h-screen bg-[#0a192f] text-gray-300 py-10"
    >
      {/* Container */}
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center h-full mt-5">
        <div className="text-center">
          <h3 className="text-4xl font-bold inline">
            My <span className="text-primary-color">Skills</span>
          </h3>
          <p className="py-4">Some of the technologies I've worked with</p>
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-8">
          {skills.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={
                "shadow-md shadow-[#040c16] hover:scale-110 duration-500" +
                " " +
                style
              }
            >
              <img className="w-20 mx-auto" src={src} alt="HTML icon" />
              <p className="my-4">{title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
